export default __webpack_public_path__ + "static/media/FAQ.f3bf7db9.pdf";